export const BROADCAST_CHANNEL_NAMES = {
  auth_user_session: 'auth_user_session',
  builder_text_updated: 'builder_text_updated',
  builder_customize_field: 'builder_customize_field',
} as const;

type BroadcastChannelName =
  | keyof typeof BROADCAST_CHANNEL_NAMES
  | `${typeof BROADCAST_CHANNEL_NAMES.builder_customize_field}_${string}`;

export class KizenBroadcastChannel<
  Message extends Record<string, any> = Record<string, any>,
> extends BroadcastChannel {
  constructor(name: BroadcastChannelName) {
    super(name);
  }

  public postMessage(data: Message) {
    super.postMessage(data);
  }

  public set onmessage(
    onMessage:
      | null
      | ((this: BroadcastChannel, event: MessageEvent<Message>) => void)
  ) {
    super.onmessage = onMessage;
  }
}
